import { AppNS } from 'app';
import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

import { TREE_PROTECTION_QUESTION_EXTENDED_ID, TREE_PROTECTION_QUESTION_SPECIAL_ID } from './inspection-checklist.const';
import { TreeProtectionQuestion } from './validation-schema';

export const parseTreeQuestions = (
  stateAnswers: RadioQuestion[]
): TreeProtectionQuestion[] => {
  return stateAnswers.map((a) => {
    return { id: a.id, value: a.state };
  });
};

export const isTreeProtectionSpecial = (
  state: TreeProtectionQuestion[]
): string | null => {
  const result = state.find(
    (i) => i.id === TREE_PROTECTION_QUESTION_SPECIAL_ID
  );

  if (!result) {
    return null;
  }

  return result.value;
};

export const isShowTreeProtectionExtended = (
  state: TreeProtectionQuestion[]
): boolean => {
  const result = state.find(
    (i) => i.id === TREE_PROTECTION_QUESTION_EXTENDED_ID && i.value === 'yes'
  );
  if (result && isTreeProtectionSpecial(state) !== 'no') {
    return true;
  }
  return false;
};

export const disableOptions = (
  stateAnswers: RadioQuestion[]
): RadioQuestion[] => {
  return stateAnswers.map((answer, index) => {
    if (index > 0) {
      return { ...answer, disabled: true };
    }
    return { ...answer };
  });
};

export const enableOptions = (
  stateAnswers: RadioQuestion[]
): RadioQuestion[] => {
  return stateAnswers.map((answer) => {
    return { ...answer, disabled: false };
  });
};

export const checkFailMatrix = (
  value: TreeProtectionQuestion[],
  matrix: (boolean | null)[]
): boolean => {
  return value.find((item, index) => item.value === matrix[index])
    ? true
    : false;
};

export const getListData = (
  dictionary: Array<{ id: string; name: string }>,
  data: string[],
  customData: string
): Array<{ id: string; name: string }> => {
  if (!data.length) {
    return [];
  }
  const output = dictionary.filter((item) => data.includes(item.id));

  return [...output, ...getListDataCustomData(customData)];
};

export const getListDataCustomData = (
  data: string
): Array<{ id: string; name: string }> => {
  if (!data) {
    return [];
  }

  return data.split(',').map((item) => {
    return {
      id: item,
      name: item,
    };
  });
};

export const setQuestionsState = (
  dictionary: RadioQuestion[],
  data: TreeProtectionQuestion[]
): RadioQuestion[] => {
  if (!data.length) {
    return dictionary;
  }
  return dictionary.map((item) => {
    const stateItem = data.find((i) => item.id === i.id);
    if (stateItem) {
      return { ...item, state: stateItem.value };
    }
    return { ...item };
  });
};

export const parseQuestionsData = (
  data: AppNS.Params
): TreeProtectionQuestion[] => {
  if (!data) {
    return [];
  }

  return Object.keys(data).map(function (key) {
    return {
      id: key,
      value: data[key],
    };
  });
};

export const parseQuestionsOutput = (
  questionsList: TreeProtectionQuestion[]
): AppNS.Params => {
  let output: AppNS.Params = {};

  questionsList.forEach((q) => {
    output[q.id] = q.value ? 'yes' : 'no';
  });

  return output;
};
